/* ⭐ R550 · Luftfracht-Rechner: Summe mitlaufend (Handy/Tablet) + Ankunft am Rechner zeigen.
 *
 * Marcel 24.09.2026: „Luftfracht schätzen — dass sich dann auch der Rechner öffnet … den
 * Luftfracht-Rechner möchte ich gerne noch ein bisschen besser haben."
 *
 * 1. Mitlaufende Summe: Unter 1100 px stehen Eingabe und Ergebnis untereinander. Die Summe lag
 *    am iPhone ~800 px unter dem ersten Feld — wer tippt, sieht nicht, was sich ändert. Die Leiste
 *    (Markup in sections/usparts-luftfracht-rechner.liquid) erscheint, solange die Eingabe im Bild
 *    ist und die Summe selbst nicht. Sie liest den Wert aus dem Ergebnis — rechnet NICHT selbst
 *    (eine Quelle: assets/usp-luftfracht.js).
 * 2. Ankunft: Wer über „Luftfracht schätzen" kommt (#rechner-rechnen), sieht die Eingabe kurz
 *    rot umrandet — damit klar ist, wo es losgeht. Kein Fokus: am Handy würde sonst sofort die
 *    Tastatur aufspringen und die Hälfte des Rechners verdecken.
 */
(function () {
  var root = document.querySelector('[data-usp-lf]');
  if (!root) return;
  var grid = root.querySelector('.usp-lf__grid');
  var leiste = root.querySelector('[data-usp-lf-leiste]');
  var wert = root.querySelector('[data-usp-lf-leiste-v]');
  var gesamt = root.querySelector('[data-usp-lf-gesamt]');
  var gesamtBox = root.querySelector('.usp-lf__gesamt');
  var ergebnis = root.querySelector('[data-usp-lf-ergebnis]');

  /* ── 1. Mitlaufende Summe ── */
  if (grid && leiste && wert && gesamt && gesamtBox && ergebnis && 'IntersectionObserver' in window) {
    // An <body> hängen: .page-wrapper scrollt per Lenis — ein Vorfahr mit transform würde position:fixed
    // an sich binden statt ans Fenster (Lehre fixed-haengt-am-naechsten-transform).
    document.body.appendChild(leiste);
    var schmal = window.matchMedia('(max-width: 1099px)');
    var eingabeImBild = false, summeImBild = false;
    var zeigen = function () {
      var text = (gesamt.textContent || '').trim();
      var an = schmal.matches && eingabeImBild && !summeImBild && !ergebnis.hidden && text !== '';
      if (text !== wert.textContent) wert.textContent = text;
      if (leiste.hidden === an) leiste.hidden = !an;
      document.documentElement.classList.toggle('usp-lf-leiste-an', an); // WhatsApp-Blase sitzt sonst genau darunter
    };
    new IntersectionObserver(function (e) { eingabeImBild = e[0].isIntersecting; zeigen(); }, { rootMargin: '0px 0px -30% 0px' }).observe(grid);
    new IntersectionObserver(function (e) { summeImBild = e[0].isIntersecting; zeigen(); }).observe(gesamtBox);
    new MutationObserver(zeigen).observe(gesamt, { childList: true, characterData: true, subtree: true });
    new MutationObserver(zeigen).observe(ergebnis, { attributes: true, attributeFilter: ['hidden'] });
    if (schmal.addEventListener) schmal.addEventListener('change', zeigen);
  }

  /* ── 2. Ankunft am Rechner ── */
  if (grid && grid.id) {
    var markieren = function () {
      grid.classList.remove('is-ankunft');
      void grid.offsetWidth; // Animation neu starten, auch beim zweiten Klick
      grid.classList.add('is-ankunft');
      setTimeout(function () { grid.classList.remove('is-ankunft'); }, 2000);
    };
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#' + grid.id + '"]');
      if (a) setTimeout(markieren, 500);
    });
    if (location.hash === '#' + grid.id) setTimeout(markieren, 900);
  }

  /* ── 3. Zwei Schritte statt Zahlenwand (R553) ──────────────────────────────
     Marcel 24.09.: „zu crazy mit diesen ganzen Zahlen … checkt kein Mensch, wenn man das zum ersten
     Mal sieht. Mobil noch viel schlimmer." Am iPhone standen ~4.400 px Zahlen am Stück (Eingabe,
     zwei Ergebnisblöcke, sechs Klassen × drei Spalten). Jetzt: 01 Beispiel wählen (füllt die Maße),
     02 Warenwert, dann EINE Summe. Maße, Aufschlüsselung und Preisliste bleiben vollständig im
     Dokument, stehen aber eingeklappt dahinter. Ohne JavaScript bleibt alles offen. */
  var f = function (k) { return root.querySelector('[data-usp-lf="' + k + '"]'); };
  var genau = root.querySelector('[data-usp-lf-genau]');
  var genauK = root.querySelector('[data-usp-lf-genau-k]');
  var genauTxt = root.querySelector('[data-usp-lf-genau-txt]');
  var eigen = root.querySelector('[data-usp-lf-eigen]');
  if (genau && genauK && genauTxt && f('l')) {
    var zusammenfassen = function () {
      var l = f('l').value, b = f('b').value, h = f('h').value, kg = f('kg').value, n = parseInt(f('pakete').value, 10) || 1;
      // R573 · Feld „pakete“ heißt fachlich „Kartons“; Bestellungen (Konsolidierung) nur zeigen, wenn es mehr als eine ist
      var nb = f('bestellungen') ? (parseInt(f('bestellungen').value, 10) || 1) : 1;
      // R573c · Ab 2 Kartons nicht die Maße des ERSTEN zeigen (las sich wie die ganze Sendung), sondern Zahl und Gesamtgewicht
      var summeKg = Array.prototype.reduce.call(root.querySelectorAll('[data-usp-lf="kg"]'), function (s, x) { var v = parseFloat(String(x.value).replace(',', '.')); return s + (v > 0 ? v : 0); }, 0);
      genauTxt.textContent = n > 1
        ? (summeKg > 0 ? n + ' Kartons · zusammen ' + summeKg.toLocaleString('de-DE', { maximumFractionDigits: 2 }) + ' kg' + (nb > 1 ? ' · ' + nb + ' Bestellungen' : '') : 'Karton-Maße und Gewicht eingeben')
        : (l && b && h && kg)
          ? 'Karton ' + l + ' × ' + b + ' × ' + h + ' cm · ' + String(kg).replace('.', ',') + ' kg'
          : 'Karton-Maße und Gewicht eingeben';
    };
    var auf = function (offen) { genau.classList.toggle('is-zu', !offen); genauK.setAttribute('aria-expanded', offen ? 'true' : 'false'); };
    genauK.hidden = false;
    auf(false);
    genauK.addEventListener('click', function () { auf(genau.classList.contains('is-zu')); });
    root.addEventListener('input', zusammenfassen);
    root.addEventListener('change', function () { setTimeout(zusammenfassen, 0); }); // R573: Abgleich Kartons/Bestellungen läuft beim change
    root.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-usp-lf-preset]')) { if (eigen) eigen.classList.remove('is-on'); setTimeout(zusammenfassen, 0); }
      if (e.target.closest('[data-usp-lf-step]')) setTimeout(zusammenfassen, 0);
    });
    if (eigen) eigen.addEventListener('click', function () {
      Array.prototype.forEach.call(root.querySelectorAll('[data-usp-lf-preset]'), function (c) { c.classList.remove('is-on'); });
      eigen.classList.add('is-on');
      auf(true);
      var l = f('l'); if (l) { try { l.focus(); l.select(); } catch (_) {} }
    });
    // usp-luftfracht.js füllt das erste Beispiel beim Start ein (nach diesem Skript) — danach zusammenfassen
    document.addEventListener('DOMContentLoaded', zusammenfassen);
    zusammenfassen();
  }

  /* Preisliste: eingeklappt, der Kopf mit dem Pflichtsatz bleibt stehen; „Alle Preise ansehen" öffnet */
  var preise = root.querySelector('.usp-lf__preise');
  var preiseGrid = preise && preise.querySelector('.usp-lf__preise-grid');
  if (preise && preiseGrid) {
    var pk = document.createElement('button');
    pk.type = 'button'; pk.className = 'usp-lf__preise-auf';
    pk.innerHTML = 'Alle Preise und Zusatzposten ansehen <span aria-hidden="true">↓</span>';
    preise.insertBefore(pk, preiseGrid);
    preise.classList.add('is-zu');
    var oeffnen = function () { preise.classList.remove('is-zu'); pk.hidden = true; };
    pk.addEventListener('click', oeffnen);
    if (preise.id) {
      if (location.hash === '#' + preise.id) oeffnen();
      window.addEventListener('hashchange', function () { if (location.hash === '#' + preise.id) oeffnen(); });
      document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href*="#' + preise.id + '"]'); if (a) oeffnen(); });
    }
  }

  /* Ergebnis unter 1100 px: Summe + Knopf zuerst, die zwei Aufschlüsselungs-Blöcke auf Wunsch */
  if (ergebnis) {
    var bloecke = ergebnis.querySelectorAll('.usp-lf__block');
    if (bloecke.length) {
      var ak = document.createElement('button');
      ak.type = 'button'; ak.className = 'usp-lf__aufschl';
      ak.textContent = 'Aufschlüsselung ansehen';
      ergebnis.insertBefore(ak, bloecke[0]);
      ergebnis.classList.add('kann-zu', 'is-zu');
      ak.addEventListener('click', function () {
        var zu = ergebnis.classList.toggle('is-zu');
        ak.textContent = zu ? 'Aufschlüsselung ansehen' : 'Aufschlüsselung schließen';
      });
    }
  }
})();
